import { ApplicationLoader } from '@cdab/scania/qpr/components'
import { UserProvider } from '@cdab/scania/qpr/contexts/user-provider'
import { Outlet } from 'react-router'

export function WithUser() {
  return (
    <UserProvider fallback={<ApplicationLoader />}>
      <Outlet />
    </UserProvider>
  )
}
